<div class="header_search">
  <div class="title-page">
    <h3>Documentos</h3>
  </div>
  <div class="content_search">
    <div class="new-project" *ngIf="permission?.canCreateDoc" >
      <a type="button" class="btn btn-primary btn" [routerLink]="novo()" [queryParams]="typeQueryParams()">Novo</a>
    </div>
  </div>
</div>

<div class="system-table table-container" *ngIf="permission?.canSeeDoc">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Título</th>
          <th>Descrição</th>
          <th>Arquivo</th>
          <th>Autor</th>
          <th>Data</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let documento of documentoList; let i = index">
          <tr>
            <td class="title"><span class="title-span">{{ documento?.title }}</span></td>
            <td>{{ documento?.description }}</td>
            <td>
              <p (click)="download(documento)" class="download">{{ documento?.name }}</p>
            </td>
            <td>{{ documento?.user }}</td>
            <td>{{ documento?.created_at }}</td>
            <td class="btn-icon-td">
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="updateClickHandler(documento)" [queryParams]="typeQueryParams()" *ngIf="permission?.canEditDoc">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
                <span class="icon-table icon-red" (click)="confirmExcluir(documento)" *ngIf="permission?.canEditDoc">
                  <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                </span>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="documentoList?.length == 0" class="border-b-radius">
          <td colspan="6" class="text-center">Nenhum Documento Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>